"use strict";
// A generic catalog list
Object.defineProperty(exports, "__esModule", { value: true });
var mockGeneralCatalogItemList = [
    { id: 0, code: 'foo', name: 'Foo' },
    { id: 1, code: 'bar', name: 'Bar' },
];
exports.default = mockGeneralCatalogItemList;
//# sourceMappingURL=mockGeneralCatalogItemList.js.map